import React from 'react';
import { FileText } from 'lucide-react';
import type { Article, ResultSectionConfig } from '../../utils/types';
import { useI18n } from '../../i18n/I18nContext';
import { useFontSizes } from '../../contexts/FontSizeContext';
import { ArticleCard } from '../ArticleCard';

interface ArticleResultsWidgetProps {
  config: ResultSectionConfig;
  articles: Article[];
}

export const ArticleResultsWidget: React.FC<ArticleResultsWidgetProps> = ({
  config,
  articles,
}) => {
  const { t } = useI18n();
  const { small } = useFontSizes();

  if (articles.length === 0) return null;

  const items = config.maxItems ? articles.slice(0, config.maxItems) : articles;
  const displayMode = config.displayMode ?? 'list';

  return (
    <section className="mb-8">
      <h3 className={`flex items-center gap-1.5 ${small} font-semibold uppercase tracking-wider text-gray-500 mb-4`}>
        <FileText className="h-3.5 w-3.5" />
        {config.title ?? t('section.articles')}{' '}
        <span className="text-gray-400 font-normal">({items.length})</span>
      </h3>

      {displayMode === 'grid' ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {items.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {items.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      )}
    </section>
  );
};
